import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ZenithComponentsModule } from '@mateco/zenith-webcomponents-angular/dist/zenith-webcomponents-angular';
import { ProtocolContainer } from './components/protocol-container/protocol.container';

import { ProtocolFormComponent } from './components/protocol-form/protocol-form.component';
import { TranslateModule } from '@ngx-translate/core';
import { ProtocolToggleComponent } from './components/protocol-form/lines/toggle/protocol-toggle.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ProtocolSubTitleComponent } from './components/protocol-form/lines/sub-title/protocol-sub-title.component';
import { ProtocolConditionalTextAreaComponent } from './components/protocol-form/lines/conditional-textarea/protocol-conditional-text-area.component';
import { ProtocolCustomerCardComponent } from './components/protocol-form/cards/customer-card/protocol-customer-card.component';
import { ProtocolCustomCardComponent } from './components/protocol-form/cards/custom-card/protocol-custom-card.component';
import { ProtocolSignatureComponent } from './components/protocol-form/lines/signature/protocol-signature.component';
import { ProtocolHeaderCardComponent } from './components/protocol-form/cards/header-card/protocol-header-card.component';
import { ProtocolPhotosComponent } from './components/protocol-form/lines/photos/protocol-photos.component';
import { SharedModule } from '@shared/*';
import { ProtocolDurationComponent } from './components/protocol-form/lines/duration/protocol-duration.component';
import { ProtocolNumericInputComponent } from './components/protocol-form/lines/numeric-input/protocol-numeric-input.component';
import { ProtocolEmailReceiversComponent } from './components/protocol-form/cards/customer-card/email-receivers/protocol-email-receivers.component';
import { PhotoUploadComponent } from '../components/photo-upload/photo-upload.component';
import { ProtocolReadOnlyComponent } from './components/protocol-form/lines/read-only/protocol-read-only.component';
import { ProtocolEmailInputComponent } from './components/protocol-form/cards/customer-card/email-input/protocol-email-input.component';
import { SmallNotificationComponent } from '../components/zenith/small-notification/small-notification.component';
import { ZenithCustomComponentsModule } from '../components/zenith/zenith-custom-components.module';
import { InputTextComponent } from '../components/form/input-text.component';
import { InvalidAsyncPipe } from '../shared/pipes/invalid-async.pipe';

@NgModule({
  declarations: [
    ProtocolConditionalTextAreaComponent,
    ProtocolContainer,
    ProtocolCustomCardComponent,
    ProtocolCustomerCardComponent,
    ProtocolDurationComponent,
    ProtocolEmailReceiversComponent,
    ProtocolHeaderCardComponent,
    ProtocolFormComponent,
    ProtocolNumericInputComponent,
    ProtocolPhotosComponent,
    ProtocolSignatureComponent,
    ProtocolSubTitleComponent,
    ProtocolToggleComponent,
    ProtocolReadOnlyComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
    ZenithComponentsModule,
    InputTextComponent,
    ZenithCustomComponentsModule,
    SharedModule, // TODO Remove if ChecklistSignatureComponent has moved into this module
    PhotoUploadComponent,
    ProtocolEmailInputComponent,
    SmallNotificationComponent,
    InvalidAsyncPipe
  ],
  exports: [ProtocolContainer, ProtocolFormComponent]
})
export class ProtocolModule {}
